"use client";

import { CheckIcon } from "@heroicons/react/20/solid";

import { Button } from "@/components/buttons/Button";
import { Heading4 } from "@/components/text/Heading4";
import { NormalText } from "@/components/text/NormalText";
import { useSetAuthModalOpen } from "@/lib/clerk/useSetAuthModalOpen";
import { usePricingModal } from "@/lib/zustand/usePricingModal";
import { UserNoDates } from "@/types/types";

export function NeedPaid({ user }: { user: UserNoDates | null }) {
  const setPricingModalOpen = usePricingModal((state) => state.setOpen);
  const setAuthModalOpen = useSetAuthModalOpen();

  const onUpgrade = () => {
    if (user === null) {
      setAuthModalOpen();
      return;
    }
    setPricingModalOpen();
  };

  const upgradeBenefits = [
    "More conversion time",
    "Access to all royalty-free voices + new",
    "Additional slots for mixed voices",
    "Commercial use of your conversions",
    "WAV (24-bit) file downloads",
    "Training of custom voices",
  ];

  return (
    <div className="mx-auto max-w-md rounded-3xl bg-primaryLight p-4">
      <Heading4 elementType="h3" className="mb-2 text-center">
        Upgrade to favorite voices
      </Heading4>

      <NormalText elementType="p">
        Upgrade to a paid plan to be able to favorite voices. In addition to
        this, you&apos;ll also receive:
      </NormalText>

      <ul className="mt-4 space-y-3">
        {upgradeBenefits.map((benefit) => (
          <li key={benefit} className="flex gap-x-2">
            <CheckIcon
              className="h-5 w-5 flex-none text-primary"
              aria-hidden="true"
            />
            <NormalText elementType="span" className="text-sm font-medium">
              {benefit}
            </NormalText>
          </li>
        ))}
      </ul>

      <Button
        variant="primary"
        onClick={onUpgrade}
        className="mx-auto mt-6 block"
      >
        Upgrade to unlock custom voices
      </Button>
    </div>
  );
}
